import WidgetStatsContainer from 'components/WidgetStats/WidgetStatsContainer'
import WidgetStatsPresentation from 'components/WidgetStats/WidgetStatsPresentation'
import WidgetStatsData from 'components/WidgetStats/WidgetStatsData'

export default {
  Container: WidgetStatsContainer,
  Presentation: WidgetStatsPresentation,
  Data: WidgetStatsData,
}
